var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 50px;\n  height: 50px;\n  margin-right: 15px;\n\n  ", "\n"], ["\n  width: 50px;\n  height: 50px;\n  margin-right: 15px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 80px;\n    height: 80px;\n    margin-right: 20px;\n  "], ["\n    width: 80px;\n    height: 80px;\n    margin-right: 20px;\n  "])));
});
export default Image;
var templateObject_1, templateObject_2;
